<template>
  <vue-content-loading :height="300" preserveAspectRatio="none">
    <rect x="0" y="40" rx="4" ry="4" width="300" height="30" />
    <rect x="0" y="120" rx="4" ry="4" width="400" height="20" />
    <rect x="0" y="170" rx="4" ry="4" width="400" height="20" />
    <rect x="0" y="220" rx="4" ry="4" width="400" height="20" />
  </vue-content-loading>
</template>

<script>
import { VueContentLoading } from "vue-content-loading"

export default {
  name: "news-loading-skeleton",
  components: { VueContentLoading }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/homebase/GenericLoadingSkeleton.vue